<input #fileUpload (change)="onFileChange($event)" class="file-input" multiple="true" type="file"/>

<div class="d-flex flex-row">
  <button (click)="fileUpload.click()" class="btn btn-primary" type="button">
    <i class="fas fa-upload"></i>
  </button>
  <span class="ms-2 mt-2">{{ !filePath ? 'Seleziona uno o più file' : filePath }}</span>
</div>
